import NbrOfAccountsText from '@/components/custom/NbrOfAccountsText.tsx';
import BadgeUserCertified from './BadgeUserCertified';
import { isEmptyString } from '@/lib/utils.ts';
import IconCoins from './IconCoins';

type TProps = {
	reviewerName?: string;
	hasIncognito?: boolean;
	hideTitle?: boolean;
	userId: string;
	adminUsername?: string;
	coins?: number;
	deviceBanCount: number;
	deviceAccountsCount?: number;
	className?: string;
	hideCoins?: boolean;
};

const ProfileBottomStats = ({
	coins,
	userId,
	hasIncognito,
	adminUsername,
	reviewerName,
	hideTitle = false,
	deviceAccountsCount = 0,
	deviceBanCount,
	className,
	hideCoins = false
}: TProps) => {

	if (!(
		!hideTitle ||
		!hideCoins ||
		hasIncognito ||
		(deviceBanCount > 0) ||
		(deviceAccountsCount >= 2) ||
		!isEmptyString(reviewerName) ||
		!isEmptyString(adminUsername)
	)) {
		return <></>;
	}

	return (
		<div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
			{
				!hideTitle &&
				<span className={'text-center font-semibold text-sm'}>
					Plus d'infos
				</span>
			}
			{
				!hideCoins &&
				<div className={'flex items-center justify-center space-x-1.5 text-sm text-gray-500'}>
					<IconCoins />
					<span>
						Pièces: {(coins ?? 0).toLocaleString('fr-FR')}
					</span>
				</div>
			}
			{
				hasIncognito &&
				<span className={'text-center text-sm text-gray-500'}>
					🥸 Incognito: OUI
				</span>
			}
			{
				deviceBanCount > 0 &&
				<span className={'text-center text-sm text-gray-500'}>
					🚫 Déja banni: {deviceBanCount} fois
				</span>
			}
			<NbrOfAccountsText
				align='center'
				userId={userId}
				deviceAccountsCount={deviceAccountsCount} />
			{
				!isEmptyString(reviewerName) &&
				<p className={'flex items-center space-x-1 justify-center text-sm text-muted-foreground'}>
					<BadgeUserCertified
						forceDisplay 
						size={20}  />
					<span>
						Certifié par: {reviewerName}
					</span>
				</p>
			}
			{
				!isEmptyString(adminUsername) &&
				<span className={'text-center text-sm text-gray-500'}>
					🗑️ Supprimé par: {adminUsername}
				</span>
			}
		</div>
	);

};

export default ProfileBottomStats;
